
import Vue from 'vue';
import _isEmpty from 'lodash/isEmpty';
import { mapGetters, mapState } from 'vuex';
import { ROUTER } from '@/router/constants';
import { UPSELL_TYPE } from '@/constants/constants';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import TeamPicker from '@/components/TeamPicker.vue';
import BorderSelectCard from '@/components/BorderSelectCard.vue';
import RdBorderCardUpsell from '@/components/RdBorderCardUpsell.vue';
import RunnitsOwnerSelectionCard from '@/views/Runnits/RunnitsOwnerSelectionPicker/RunnitsOwnerSelectionCard.vue';
import { RunnitsOwnerSelection } from '@/store';

export default Vue.extend({
	name: 'RunnitsOwnerSelectionPicker',
	data () {
		return {
			UPSELL_TYPE,
			RUNNITS_OWNER_SELECTION,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
			'toolbar',
			'runnitState',
		]),
		...mapGetters([
			'displayLabels',
		]),
		items () {
			return [
				{
					value: RUNNITS_OWNER_SELECTION.USER,
					label: 'Personal Account',
					icon: 'mdi-account-outline',
					descriptionHtml: `<div>Boards and generations will be saved under your personal <b>account</b> and will use your personal <b>balance</b></div>`,
				},
				{
					value: RUNNITS_OWNER_SELECTION.TEAM,
					label: `${this.displayLabels.team} Account`,
					icon: 'mdi-account-multiple-outline',
					descriptionHtml: `<div>Boards and generations will be saved under your ${this.displayLabels.team} <b>account</b> as either "Private" or "Shared" and will use your ${this.displayLabels.team} shared <b>balance</b></div>`,
				},
			];
		},
	},
	methods: {
		_isEmpty,
		doUpsellToTeamPlan () {
			if (this.toolbar.session) {
				const routeData = this.$router.resolve({ name: ROUTER.COMPANY_DASHBOARD });
				window.open(routeData.href, '_blank');
			} else {
				this.routerPush(this.$route, this.$router, { name: ROUTER.COMPANY_DASHBOARD });
			}
			this.onSelect(RUNNITS_OWNER_SELECTION.TEAM);
		},
		onSelect (runnitsOwnerSelection: RunnitsOwnerSelection) {
			this.$emit('on-select', runnitsOwnerSelection);
		},
		onTeamSelect ({ team }) {
			if (team) {
				this.$emit('on-select', RUNNITS_OWNER_SELECTION.TEAM);
			}
		},
	},
	components: {
		TeamPicker,
		RdBorderCardUpsell,
		BorderSelectCard,
		RunnitsOwnerSelectionCard,
	},
});
